(function(){
  function init(){
    if(document.getElementById('cs-site-feedback')) return;
    var footer=document.querySelector('footer');
    if(!footer) return;
    var wrap=document.createElement('div');
    wrap.id='cs-site-feedback';
    wrap.innerHTML=`
      <div class="cs-feedback-inner">
        <button class="cs-feedback-link" type="button" aria-expanded="false" aria-controls="cs-feedback-panel">Spotted something not quite right?</button>
        <div class="cs-feedback-panel" id="cs-feedback-panel" hidden>
          <button class="cs-feedback-close" type="button" aria-label="Close">×</button>
          <p class="cs-feedback-kicker">A LITTLE HELP FROM YOU</p>
          <h2>Help us make Custom Sugar even sweeter</h2>
          <p class="cs-feedback-copy">Spotted something on our website that doesn’t look right or isn’t working as expected? We’d love to know. Tell us what happened and, if you can, which page you were on. We’ll take a look.</p>
          <form method="post" action="/contact#cs-site-feedback" accept-charset="UTF-8">
            <input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="contact[Subject]" value="Website feedback">
            <div class="cs-feedback-grid">
              <label>Your name <span>(optional)</span><input type="text" name="contact[name]" autocomplete="name"></label>
              <label>Email <span>(optional)</span><input type="email" name="contact[email]" autocomplete="email"></label>
            </div>
            <label>Which page?<input type="text" name="contact[Page]" value="${location.pathname}" placeholder="e.g. Space Cake"></label>
            <label>What happened?<textarea name="contact[body]" rows="4" required placeholder="Tell us what you noticed…"></textarea></label>
            <button class="cs-feedback-submit" type="submit">Send feedback</button>
          </form>
        </div>
      </div>`;
    footer.appendChild(wrap);
    var trigger=wrap.querySelector('.cs-feedback-link'), panel=wrap.querySelector('.cs-feedback-panel'), close=wrap.querySelector('.cs-feedback-close');
    function setOpen(open){panel.hidden=!open;trigger.setAttribute('aria-expanded',open?'true':'false'); if(open) setTimeout(function(){panel.scrollIntoView({behavior:'smooth',block:'nearest'});},30);}
    trigger.addEventListener('click',function(){setOpen(panel.hidden);});
    close.addEventListener('click',function(){setOpen(false);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();